jQuery(function($)
{
    if ($('#checkout-address').length === 0)
    {
        return;
    }

    var
        fixBackground = 'no-scroll',
        $body = $('body');

    /**
	 * @type {string}
	 */
    var currentClass = 'current';

    /**
	 * @type {jQuery}
	 */
    var $submitButton = $('button[name=\'submit\']');

    /**
	 * @type {jQuery}
	 */
    var $formArrangement = $('#checkout-address-form-arrangement');

    /**
	 * @type {jQuery}
	 */
    var $formShipping = $('#checkout-address-form-shipping');

    /**
	 * @type {jQuery}
	 */
    var $formBilling = $('#checkout-address-form-billing');

    /**
	 * @type {jQuery}
	 */
    var $formNewAddress = $('.js-form-address-overlay');

    /**
	 * @type {jQuery}
	 */
    var $formTriggers = $('.js-form-trigger');

    /**
	 * @type {jQuery}
	 */
    var $orderFormShippingMode = $('#orderFormShippingMode');

    /**
	 * @type {jQuery}
	 */
    var $orderFormShippingAddressId = $('#orderFormShippingAddressId');

    /**
	 * @type {jQuery}
	 */
    var $addressList = $('.js-alternative-address-id');

    var addressBox = document.querySelector('.js-alternative-address-box');

    function init()
    {
        switch ($('[class*=js-radio-checked]').find('input:checked')
            .val())
        {
        case 'Billing':
            $formShipping.hide();
            $formArrangement.hide();
            break;
        case 'Shipping':
            $formBilling.hide();
            $formArrangement.hide();
            deactivateSubmitButton();
            updateShippingAddressList();
            updateOrderFormShippingAddressId();
            break;
        case 'B2BPermanentShippingOption':
        default:
            $formBilling.hide();
            $formShipping.hide();
            $('span[data-target-id=checkout-address-form-arrangement]').addClass(currentClass)
                .find('input')
                .prop('checked', true);
        }
        initEvents();
    }

    function hideForms()
    {
        $formArrangement.hide();
        $formBilling.hide();
        $formShipping.hide();
    }

    function deactivateSubmitButton()
    {
        $submitButton.addClass('disabled');
    }

    function activateSubmitButton()
    {
        $submitButton.removeClass('disabled');
    }

    function initEvents()
    {
        $formTriggers.on('click', handleClick);
        $('#new-address').on('submit', function(event)
        {
            event.preventDefault();
        });
        $('#new-address').on(orion.constants.EventFormValidationComplete, function()
        {
            let $form = $(this);

            if (typeof $form.data('valid') != 'undefined' && $form.data('valid') == true)
            {
                postNewAddress();
            }
        });

        $('body').on('change', '.js-alternative-address-id', changeSelectedAddressFlag);
    }

    function removeSelectedAddressFlags()
    {
        $('body').find('.js-alternative-address-entry')
            .each(function()
            {
                $(this).removeClass('default');
            });
    }

    function changeSelectedAddressFlag()
    {
        removeSelectedAddressFlags();
        $('.js-alternative-address-id option:selected').addClass('default');
        updateOrderFormShippingAddressId();
    }

    function fetchTargetId($element)
    {
        return $element.data('targetId');
    }

    function handleClick()
    {
        var $element = $(this);
        var targetId = fetchTargetId($element);
        var $target = $('#' + targetId);

        $('span.' + currentClass).removeClass(currentClass);
        $element.addClass(currentClass);
        $element.find('input').prop('checked', true);

        hideForms();

        if (typeof targetId != 'undefined' && $target.length > 0)
        {
            $target.show();
        }
        setStates($element);
        return false;
    }

    function setStates($element)
    {
        switch ($element.find('input').prop('id'))
        {
        case '1': {
            activateSubmitButton();
            removeOrderFormShippingAddressId();
            break;
        }
        case '2': {
            activateSubmitButton();
            removeOrderFormShippingAddressId();
            break;
        }
        case '3':
        default: {
            deactivateSubmitButton();
            updateShippingAddressList();
        }
        }
        $orderFormShippingMode.val($element.find('input').val());
    }

    function updateOrderFormShippingAddressId()
    {
        /**
		 * @type {jQuery}
		 */
        var $addressEntries = $('.js-alternative-address-id option');

        $addressEntries.each(function()
        {
            if ($(this).hasClass('default'))
            {
                var $input = $(this);

                setOrderFormShippingAddressId($input.val());
                $submitButton.removeClass('disabled');
                addressBox.classList.remove('hidden');
            }
        });
    }

    function removeOrderFormShippingAddressId()
    {
        $orderFormShippingAddressId.val('');
    }

    function setOrderFormShippingAddressId($id)
    {
        $orderFormShippingAddressId.val($id);
    }

    function updateShippingAddressList()
    {
        var $promise = $.ajax('/api-customer-de/shipping-addresses', {
            cache: false,
            headers: {
                'Accept': 'application/json',
            },
            method: 'GET',
            dataType: 'json',
            statusCode: {
                404: function()
                {
                    addressBox.classList.add('hidden');
                    /* TODO show feedback */
                }
            }
        });

        $promise.done(function(data)
        {
            clearShippingAddressList();
            var $defaultId = data['defaultShippingAddressId'];
            var $items = data['shippingAddresses'];

            $.each($items, function(_, value)
            {
                insertShippingAddressEntry(value, $defaultId);
            });

            updateOrderFormShippingAddressId();
        });
    }

    function postNewAddress()
    {
        var $data = {
            'shippingMode': 'Shipping',
            'shippingAddress': {
                'addressType': $('input[name=\'shippingAddress[addressType]\']').val(),
                'firstName': $('input[name=\'shippingAddress[firstName]\']').val(),
                'lastName': $('input[name=\'shippingAddress[lastName]\']').val(),
                'street': $('input[name=\'shippingAddress[street]\']').val(),
                'zipcode': $('input[name=\'shippingAddress[zipcode]\']').val(),
                'city': $('input[name=\'shippingAddress[city]\']').val(),
                'countryCode': $('select[name=\'shippingAddress[countryCode]\']').val(),
                'additionalLine': $('input[name=\'shippingAddress[additionalLine]\']').val(),
                'isDefault': true
            }
        };

        $.ajax('/api-customer-de/shipping-addresses', {
            cache: false,
            headers: {
                'Accept': 'application/json',
            },
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify($data),
            method: 'POST',
            statusCode: {
                201: function()
                {
                    foldNewAddress();
                    updateShippingAddressList();
                },
                400: function()
                {
                    console.log('Bad Request - new address could not be created.');
                },
                403: function()
                {
                    console.log('Forbidden. Client must be authenticated and use valid session');
                }
            }
        });
    }

    function foldNewAddress()
    {
        $formNewAddress.addClass('hidden');
        $body.removeClass(fixBackground + ' focus-active');
    }

    function clearShippingAddressList()
    {
        $addressList.empty();
    }

    function insertShippingAddressEntry($address, $defaultId)
    {
        var defaultClass = ($defaultId == $address['addressId']) ? ' default' : '';
        var selectedAttribute = (defaultClass != '') ? ' selected' : '';


        var $html = '<option value=\'' + $address['addressId'] + '\' class=\'address-container previous-addresses'
             + defaultClass + ' js-alternative-address-entry\' ' + selectedAttribute + '>'
             + '<span class=\'address-entry checkout__address-list--item js-dropdown-special__menu-item\'>'
             + '<span class=\'p-family-name\'>' + $address['lastName'] + ', </span>'
             + '<span class=\'p-additionalline\'>' + ($address['additionalLine'] == null
            ? '' : $address['additionalLine']) + ', </span>'
             + '<span class=\'p-street-address\'>' + $address['street'] + ', </span>'
             + '<span class=\'p-postal-code\'>' + $address['countryCode'] + '-' + $address['zipcode'] + ', </span>'
             + '<span class=\'p-locality\'>' + $address['city'] + ' </span>'
             + '</span>'
             + '</option>';

        $addressList.append($html);
    }

    init();
});
